var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSuccessPayment = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1872_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.92498V7.49998C13.7492 8.84774 13.3128 10.1591 12.5058 11.2386C11.6989 12.3181 10.5645 13.1078 9.27209 13.4899C7.97964 13.8721 6.59828 13.8262 5.33404 13.3591C4.0698 12.892 2.99041 12.0288 2.25685 10.8981C1.52329 9.7675 1.17487 8.43002 1.26354 7.08517C1.35222 5.74033 1.87325 4.46018 2.74892 3.43565C3.62459 2.41111 4.80799 1.69709 6.12261 1.40007C7.43724 1.10304 8.81266 1.23894 10.0437 1.78748M13.75 2.49998L7.5 8.75623L5.625 6.88123",
    stroke: "#6BA543",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1872_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccessPayment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SuccessPayment.4440ba59.svg";
export { ForwardRef as ReactComponent };